export const PHONE_MASK = "+{7} (000) 000 00 00";

export const PHONE_DIGITS_LENGTH = 11;
